import { useTranslation } from '../../../i18n/TranslationContext';

const services = [
  {
    icon: 'ri-shopping-bag-3-line',
    titleKey: 'brands.services.xiaohongshu.title',
    descKey: 'brands.services.xiaohongshu.desc',
    color: 'bg-primary-100 text-primary-700 hover:bg-primary-500 hover:text-background-50',
  },
  {
    icon: 'ri-global-line',
    titleKey: 'brands.services.global.title',
    descKey: 'brands.services.global.desc',
    color: 'bg-accent-100 text-accent-700 hover:bg-accent-500 hover:text-background-50',
  },
  {
    icon: 'ri-bar-chart-2-line',
    titleKey: 'brands.services.analytics.title',
    descKey: 'brands.services.analytics.desc',
    color: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-500 hover:text-background-50',
  },
];

export default function BrandServices() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-16 md:mb-20">
          <p className="text-xs font-medium uppercase tracking-widest text-primary-500 mb-4">
            {t('nav.brands')}
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-tight max-w-3xl mb-4">
            {t('brands.services.title')}
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl leading-relaxed">
            {t('brands.services.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {services.map((svc, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl border border-foreground-100/60 p-8 md:p-10 flex flex-col group hover:border-primary-200/60 hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-6 transition-all duration-300 ${svc.color}`}>
                <i className={`${svc.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-950 mb-2.5">
                {t(svc.titleKey)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(svc.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}